export default __webpack_public_path__ + "static/media/congratulation.bc5b3914.svg";